import ActivityList from "@/components/icons/ActivityList";
import { useEntities } from "@/contexts/entities/EntitiesContext";

type CompetencyActivityCounterProps = {
  competencyId: string;
  className?: string;
};

export const CompetencyActivityCounter = ({
  competencyId,
  className,
}: CompetencyActivityCounterProps) => {
  const { getActivitiesForCompetency } = useEntities();
  const activityCount = getActivitiesForCompetency(competencyId).length;

  if (activityCount == 0) {
    return null;
  }

  return (
    <span
      className={`ml-1 mr-2 flex h-8 items-center rounded-[15px] border border-solid border-black bg-white p-2 text-[14px] ${className}`}
    >
      <ActivityList className="mr-1" />
      {activityCount}
    </span>
  );
};
